import React from 'react'

export const GreenCheckbox = () => {
  return (<input type='checkbox'/>)
}